import { Button, Form } from "react-bootstrap"
import { useUser } from "../api/users/store"
import React, { useState } from "react"
import { AppRole } from "../api/reg/actions"
import { useReg } from "../api/reg/store"
import useUXStore from "../api/ux/store"
import ButtonControl from "../components/ButtonControl"
import RoleSelector from "./Users/RoleSelector"
import CStack from "../components/CStack"
import EmailInput from "../components/EmailInput"

const InviteComp = ({ onConfirm = (emails: string[], e: AppRole[]) => { } }) => {
    const { roles } = useUser(state => state)
    const [appRoles, setARoles] = useState<AppRole[]>()
    const [emails, setEmails] = useState<string[]>([])
    const onChangedRole = (roles: AppRole[]) => {
        setARoles(roles)
    }

    const handleConfirm = () => {
        onConfirm(emails, appRoles!)
    }

    return <>
        <CStack>
            <Form.Group controlId="inviteEmails" className="mb-3">
                <Form.Label>Emails</Form.Label>
                <EmailInput
                    emails={emails}
                    onEmailsChanged={setEmails}
                    placeholder="Enter emails separated by commas, spaces or new lines"
                />
            </Form.Group>

            <RoleSelector defs={roles!} showConfirm={false} emptyData onChanged={onChangedRole} />

        </CStack>

        <br />
        <Button disabled={!appRoles || appRoles.length === 0 || emails.length === 0} style={{ float: 'right' }} onClick={handleConfirm}>
            Invite
        </Button>
        <br />

    </>
}

type InviteDialogProps = {
    onInvited: (emails: string[], e: AppRole[]) => void
}

const InviteDialog: React.FC<InviteDialogProps> = ({ onInvited }) => {
    const { refreshDialog, addToast, hideDialog } = useUXStore(state => state)
    const { inviteMultiple } = useReg(state => state)

    const onConfirm = (emails: string[], e: AppRole[]) => {
        inviteMultiple(emails, Object.values(e as {}))
            .then(code => {
                switch (code) {
                    case "200":
                        addToast("", `Invites sent to ${emails.length} users`)
                        onInvited(emails, e)
                        break;

                    default:
                        addToast("Invite Failed", "Failed to invite users")
                        break;
                }
            }).catch(err => {

            })
        hideDialog("inviteUser")
    }
    const onClickInvite = () => {
        refreshDialog({
            id: "inviteUser",
            title: "Invite users",
            visible: true,
            content: <InviteComp onConfirm={onConfirm} />,
        }, true)
    }
    return <ButtonControl text="Invite User" onClicked={onClickInvite} buttonLabel="Invite" />
    // <Button onClick={onClickInvite}>Invite</Button>
}

export default InviteDialog